<template>
  <section class="section">
    <div class="card" v-show="showform === 'empleado'">
      <div class="card-content">
        <h2 class="subtitle">Crear Empleados</h2>
        <div class="field">
          <label class="label">Nombre</label>
          <div class="control">
            <input
                v-model="colaborador.nombre"
                class="input"
                type="text"
                placeholder="Nombre"
            />
          </div>
        </div>
        <div class="field">
          <label class="label">Cédula</label>
          <div class="control">
            <input
                v-model="colaborador.cedula"
                class="input"
                type="text"
                placeholder="Cédula"
            />
          </div>
        </div>
        <div class="field">
          <label class="label">Correo</label>
          <div class="control">
            <input
                v-model="colaborador.email"
                class="input"
                type="email"
                placeholder="Correo"
            />
          </div>
        </div>
        <div class="field">
          <label class="label">Encuesta</label>
          <div class="control">
            <input
                v-model="colaborador.quiz"
                class="input"
                type="number"
                max="3"
                min="1"
                onkeypress='return event.charCode >= 49 && event.charCode <= 51 && event.target._value.length < 1'
                placeholder="1, 2 o 3"
            />
          </div>
        </div>
        <div class="field" v-for="(item, index) in dependencias" :key="index">
          <label class="label">{{ item.nombre }}</label>
          <div class="control">
            <input
                v-model="colaborador.dependencias[item._id]"
                class="input"
                type="text"
                :placeholder="item.nombre"
            />
          </div>
        </div>
        <div class="field is-grouped">
          <div class="control">
            <button class="button is-link" @click="savecolaborador()">
              Aceptar
            </button>
          </div>
          <div class="control" @click="cancel">
            <button class="button is-light">Cancelar</button>
          </div>
        </div>
        <hr/>
        <h2 class="subtitle">
          O puedes cargar los empleados desde un archivo en excel
        </h2>
        <div class="columns">
          <div class="column is-4">
            <button
                class="button is-link"
                @click="downexemple"
                style="margin-right: 10px"
            >
            <span class="file-icon">
              <i class="material-icons">cloud_download</i>
            </span>
              <span>Descargar Formato de Ejemplo</span>
            </button>
          </div>
          <div class="column">
            <label class="file-label">
              <input
                  class="file-input"
                  type="file"
                  accept=".xls, .xlsx"
                  @change="onFileChange"
                  name="resume"
              />
              <span class="file-cta">
              <span class="file-icon">
                <i class="material-icons">cloud_upload</i>
              </span>
              <span class="file-label">Cargar Empleados</span>
            </span>
            </label>
          </div>
        </div>
        <progress
            v-show="avaceupload > 0"
            class="progress is-info is-small"
            :value="avaceupload"
            max="100"
        ></progress>
        <hr/>
      </div>
    </div>
    <div class="card" v-show="showform === 'dependencia'">
      <div class="card-content">
        <h2 class="subtitle">Crear dependencias</h2>

        <div class="columns">
          <div class="column">
            <div class="field">
              <div class="control">
                <input
                    v-model="dependencia.nombre"
                    class="input"
                    type="text"
                    placeholder="Nombre de la dependencia o categoría"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field is-grouped">
              <div class="control">
                <button class="button is-link" @click="savedependencia()">
                  Guardar
                </button>
              </div>
              <div class="control">
                <button class="button is-light" @click="cancel">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
        <table class="table is-fullwidth">
          <thead>
          <tr>
            <th></th>
            <th>Nombre</th>
            <th>Controles</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in dependencias" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.nombre }}</td>
            <td>
              <button
                  data-tooltip="Eliminar"
                  class="button is-danger tooltip"
                  @click="deleteDependencia(item)"
              >
                <span class="icon">
                  <i class="material-icons">delete_forever</i>
                </span>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <hr/>
      </div>
    </div>
    <br>
    <div class="columns">
      <div class="column">
        <p class="control has-icons-left has-icons-right">
          <input
              class="input is-medium is-focused"
              type="text"
              v-model="search"
              placeholder="Buscar Empleado"
          />
          <span class="icon is-medium is-left">
        <i class="material-icons">search</i>
      </span>
        </p>
      </div>
      <div class="column">
        <div class="buttons">
          <button
              :disabled="showform === 'empleado'"
              class="button is-medium"
              :class="showform === 'empleado'? 'is-light' : 'is-dark'"
              @click="selectshowform('empleado')"
          >
          <span class="icon">
            <i class="material-icons">add_circle</i>
          </span>
            <span>Crear Empleado</span>
          </button>
          <button
              class="button is-medium"
              :disabled="showform === 'dependencia'"
              :class="showform === 'dependencia'? 'is-light' : 'is-info'"
              @click="selectshowform('dependencia')"
          >
          <span class="icon">
            <i class="material-icons">add_circle</i>
          </span>
            <span>Dependencias</span>
          </button>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="scroll-top">
        <table style="transform: rotateX(180deg);" class="table is-fullwidth">
          <thead>
          <tr>
            <th>Nombre</th>
            <th>Correo</th>
            <th>Cédula</th>
            <th>Encuesta</th>
            <th>
            <span v-if="dependencias.length > 0" style="cursor: pointer;" @click="showDepend" class="is-size-5">{{
                this.showDependecias ? "⇇" : "⇉"
              }}</span>
            </th>
            <th v-for="(item1, index1) in (showDependecias ? dependencias : [])" :key="index1">
              {{ item1.nombre }}
            </th>
            <th class="stick-colum">
              <div class="buttons" @click="deleteAll">
                <button class="button is-fullwidth is-danger">Eliminar Todos</button>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in filteredItems" :key="index">
            <td>{{ item.nombre }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.cedula }}</td>
            <td class="has-text-centered">{{ item.quiz }}</td>
            <td></td>
            <td v-for="(item1, index1) in (showDependecias ? dependencias : [])" :key="index1">
              {{ item.dependencias ? item.dependencias[item1._id] : "" }}
            </td>
            <td class="has-text-centered stick-colum">
              <button class="button is-dark" @click="editEmpleado(item)">
              <span data-tooltip="Editar" class="icon tooltip">
                <i class="material-icons">edit</i>
              </span>
              </button>
              <button class="button is-danger" @click="eliminarEmpleado(item)">
              <span data-tooltip="Eliminar" class="icon tooltip">
                <i class="material-icons">delete_forever</i>
              </span>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import apiServices from "@/services/yungol-services";
import {mapState} from "vuex";
/* const XLSX = require("xlsx"); */

const filterItems = (query, data) => {
  return data.filter((el) => {
    const texto = el.email + el.nombre + el.cedula;
    if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      return el;
    }
  });
};

export default {
  data() {
    return {
      search: "",
      fupload: {
        url: "",
      },
      avaceupload: 0,
      showform: null,
      showDependecias: false,
      colaborador: {
        nombre: "",
        email: "",
        quiz: 1,
        dependencias: {},
      },
      colaboradores: [],
      dependencias: [],
      dependencia: {
        nombre: "",
      },
    };
  },
  props: {
    proceso: {
      type: Object,
    },
  },
  computed: {
    ...mapState(["idtoken", "modalnotification"]),
    filteredItems: function () {
      return filterItems(this.search, this.colaboradores);
    },
    resultnotification() {
      return this.modalnotification.result.aceptar;
    },
  },
  methods: {
    onFileChange(e) {
      const _this = this;
      let task;
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        task = _this.$fire.refexcel(file);
        _this.avaceupload = 10;
        task.on(
            "state_changed",
            (snapshot) => {
              const porcentaje =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              if (porcentaje > 10) {
                _this.avaceupload = porcentaje;
              }
            },
            (err) => {
              console.log("error subiendo el archivo", err);
            },
            async () => {
              try {
                const url = await task.snapshot.ref.getDownloadURL();
                _this.avaceupload = 0;
                _this.fupload.url = url;
                const data = {
                  url: url,
                  proceso: this.proceso._id,
                };
                const result = await apiServices.post(
                    `/saveempleadoslotecultura`,
                    data
                );
                if (typeof result.data === "string"){
                  await this.$store.dispatch("notify", {
                    message: result.data,
                    type: "is-warning",
                    position: "top-right",
                    duration: 3000,
                  });
                  return false;
                }else if(result.data){
                  await this.getColaboradores();
                }
              } catch (err) {
                console.log("ocurrio un error", err);
              }
            }
        );
      }
    },
    async deleteAllEmployees(procesoid) {
      try {
        await apiServices.delete(`/delallemployeescultura/${procesoid}`);
        this.getColaboradores();
      } catch (err) {
        console.log(err);
      }
    },
    deleteAll() {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "¡Cuidado!",
          message:
              "¿Realmente desea eliminar todos los empleados y sus encuestas?",
          clase: "is-white",
          data: {proceso: this.proceso._id, tipo: "deleteall"},
        },
      });
    },
    async deleteEmpleado1(idempleado) {
      await apiServices.delete(
          `/deleteoneemployeecultura/${this.proceso._id}/${idempleado}`
      );
      this.getColaboradores();
    },
    eliminarEmpleado(d) {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "¡Cuidado!",
          message: `¿Realmente desea eliminar el empleado ${d.nombre}?`,
          clase: "is-white",
          data: {tipo: "empleado", _id: d._id},
        },
      });
    },
    scrollTop() {
      window.scrollTo({
        behavior: "smooth",
        left: 0,
        top: 200,
      });
    },
    editEmpleado(d) {
      this.showform = "empleado";
      this.colaborador.nombre = d.nombre;
      this.colaborador.email = d.email;
      this.colaborador.cedula = d.cedula;
      this.colaborador.proceso = this.proceso._id;
      this.colaborador.dependencias = d.dependencias;
      this.colaborador.quiz = d.quiz;
      this.colaborador._id = d._id;
      this.scrollTop();
    },
    cancel() {
      this.showform = null;
      this.colaborador = {
        nombre: "",
        email: "",
        dependencias: {},
      };
      this.dependencia = {
        nombre: "",
      };
    },
    async deleteDependencia1(iddependencia) {
      await apiServices.delete(`/deletedependenciacultura/${iddependencia}`);
      this.getdependencias();
    },
    deleteDependencia(d) {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "¡Cuidado!",
          message: `¿Realmente desea eliminar la dependencia ${d.nombre}?`,
          clase: "is-white",
          data: {tipo: "dependencia", _id: d._id},
        },
      });
    },
    selectshowform(d) {
      this.showform = d;
    },
    async downexemple() {
      try {
        let result;
        result = await apiServices.post(
            `/downexempleempleadoscultura`,
            {proceso: this.proceso._id},
            {responseType: "blob"}
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `Ejemplo.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      }
    },
    async getdependencias() {
      try {
        const result = await apiServices.get(
            `/getdependenciacultura/${this.proceso._id}`
        );
        if (result.data) {
          this.dependencias = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async savedependencia() {
      try {
        if (!this.dependencia.nombre) {
          this.$store.dispatch("notify", {
            message: "La dependencia debe tener un nombre.",
            type: "is-warning",
            position: "top-center",
            duration: 3000,
          });
          return false;
        }
        await apiServices.post(`/savedependenciacultura`, {
          dependencia: this.dependencia,
          proceso: this.proceso._id,
        });
        this.dependencia.nombre = null;
        this.getdependencias();
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ya existe una dependencia con ese nombre.",
          type: "is-danger",
          position: "top-center",
          duration: 3000,
        });

        console.log(err);
      }
    },
    async savecolaborador() {
      try {
        if (!this.proceso._id) {
          this.$store.dispatch("notify", {
            message: "Primero debe seleccionar el proceso en el paso 1.",
            type: "is-warning",
            position: "top-center",
            duration: 3000,
          });
          return false;
        }
        this.colaborador.proceso = this.proceso._id;
        if (!this.colaborador.nombre) {
          this.$store.dispatch("notify", {
            message: "Debe incluir un nombre.",
            type: "is-warning",
            position: "top-center",
            duration: 3000,
          });
          return false;
        }
        if (!this.colaborador.cedula) {
          this.$store.dispatch("notify", {
            message: "El campo de cédula es requerido.",
            type: "is-warning",
            position: "top-center",
            duration: 3000,
          });
          return false;
        }
        let result = null
        if (this.colaborador._id) {
          result = await apiServices.post(`/editcolaboradorcultura`, this.colaborador);
        } else {
          result = await apiServices.post(`/savecolaboradorcultura`, this.colaborador);
        }
        if (typeof result.data === "string"){
          await this.$store.dispatch("notify", {
            message: result.data,
            type: "is-warning",
            position: "top-right",
            duration: 3000,
          });
          return false;
        }else {
          await this.getColaboradores();
          this.cancel();
          const _this = this;
          for (let index in _this.dependencias) {
            _this.colaborador.dependencias[_this.dependencias[index]._id] = null;
          }        }
      } catch (err) {
        console.log(err);
      }
    },
    async getColaboradores() {
      try {
        if (!this.proceso._id) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar un proceso en el paso 1.",
            type: "is-warning",
            position: "top-center",
            duration: 3000,
          });

          return false;
        }
        const result = await apiServices.get(
            `/colaboradoresculturalist/${this.proceso._id}`
        );
        if (result.data) {
          this.colaboradores = result.data.colaboradores;
          this.dependencias = result.data.dependencias;
        }
      } catch (err) {
        console.log(err);
      }
    },
    showDepend() {
      if (this.showDependecias) {
        this.showDependecias = false
      } else {
        this.showDependecias = true
      }
    },
    /* widthCols(data) {
      let values = []
      //  Se recorre todos los datos
      for (let i = 0; i < data.length; i++) {
        let cont = 0;
        // Se recorre la informacion de un Dato
        for (const d in data[i]) {
          // Si es la primera iteracion arma el dato con el tamaño del campo y lo guarda la array values
          if (i === 0) {
            let w = {width: (String(data[i][d]).length + 2)}
            values.push(w)
          }
              //  Si no es la primera iteracion compara los datos nuevo con los valores del array values
          //  con el fin de extraer el numero mas grande
          else {
            let w = (String(data[i][d]).length + 2)
            if (values[cont].width < w) {
              values[cont].width = w;
            }
            cont++;
          }
        }
      }
      // Se valian los tamaños de los titulos para evitar corte de texto en el Excel
      let cont = 0;
      for (const key in data[0]) {
        let w = (String(key).length + 2)
        if (values[cont].width < w) {
          values[cont].width = w;
        }
        cont++;
      }

      //  Se devuelve values con el formato necesario para el tamaño de columnas del Excel
      return values
    },
    dataResults(){
      const data = this.colaboradores.map((x) => {
        console.log(x)
        return {
          nombre: x.nombre,
          email: x.email,
          cedula: x.cedula,
          quiz: x.quiz,
          status: x.status,
          ...x.responses
        }
      })
      console.log(data)
      return {
        'data': [data],
        'names': ['Resultados Cultura - Prueba cultura 10 julio 23']
      }
    },
    async excel() {
      try {
        let data = await this.dataResults()
        if (data.data.length > 0) {
          //  Recorremos las diferentes datas creando un Excel para cada uno
          for (let i = 0; i < data.data.length; i++) {
            //  Asignamos la informacion necesaria a nuevas variables
            let dataExc = data.data[i];
            console.log(dataExc)
            let name = data.names[i];
            //  Se agrega la data al libro de excel
            var ws = XLSX.utils.json_to_sheet(dataExc);

            //  Se configura el tamaño de cada columna
            const widths = this.widthCols(dataExc);
            ws["!cols"] = widths

            //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Colaboradores");
            var nombreArchivo = name + ".xlsx";
            XLSX.writeFile(wb, nombreArchivo);

          }
        } else {
          this.$store.dispatch("notify", {
            message: `No hay datos para descargar`,
            type: "is-link",
          });
        }

      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    }, */
  },
  watch: {
    resultnotification(nv, ov) {
      if (nv) {
        if (this.modalnotification.result.data.tipo === "dependencia") {
          this.deleteDependencia1(this.modalnotification.result.data._id);
        } else if (this.modalnotification.result.data.tipo === "empleado") {
          this.deleteEmpleado1(this.modalnotification.result.data._id);
        } else if (this.modalnotification.result.data.tipo === "deleteall") {
          this.deleteAllEmployees(this.modalnotification.result.data.proceso);
        }
      }
    },
  },
  created() {
    this.getColaboradores();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cultura/Empleadosc.vue